function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
export function withLink(Component) {
  var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Link';

  function Link(props) {
    var _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        _props$size = props.size,
        size = _props$size === void 0 ? 'md' : _props$size,
        className = props.className,
        domRef = props.domRef,
        onClick = props.onClick,
        extra = _objectWithoutProperties(props, ["disabled", "size", "className", "domRef", "onClick"]);

    var handleClick = useRefCallback(function (event) {
      if (disabled) {
        return event.preventDefault();
      }

      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    });
    var cls = classnames(usePrefixCls('link', {
      disabled: disabled,
      size: size
    }), className);
    return React.createElement(Component, Object.assign({
      tabIndex: 0
    }, extra, {
      className: cls,
      onClick: handleClick,
      ref: domRef
    }));
  }

  Link.displayName = displayName;
  return Link;
}